const STORAGE_PREFIX = 'exam-pending-submission:';
const DRAFT_PREFIX = 'exam-answer-draft:';

const storageKey = (attemptId) => `${STORAGE_PREFIX}${attemptId}`;

export const savePendingSubmission = (submission) => {
    if (!submission?.attemptId || !submission?.examId) return false;
    try {
        localStorage.setItem(storageKey(submission.attemptId), JSON.stringify({
            ...submission,
            savedAt: new Date().toISOString(),
        }));
        return true;
    } catch {
        return false;
    }
};

export const removePendingSubmission = (attemptId) => {
    try {
        localStorage.removeItem(storageKey(attemptId));
    } catch {}
};

export const saveAnswerDraft = (draft) => {
    if (!draft?.attemptId || !draft?.examId || !draft?.answers) return false;
    try {
        localStorage.setItem(`${DRAFT_PREFIX}${draft.attemptId}`, JSON.stringify({
            ...draft,
            savedAt: new Date().toISOString(),
        }));
        return true;
    } catch {
        return false;
    }
};

export const loadAnswerDraft = (attemptId) => {
    try {
        const draft = JSON.parse(localStorage.getItem(`${DRAFT_PREFIX}${attemptId}`));
        return draft?.attemptId && draft?.answers ? draft : null;
    } catch {
        return null;
    }
};

export const removeAnswerDraft = (attemptId) => {
    try {
        localStorage.removeItem(`${DRAFT_PREFIX}${attemptId}`);
    } catch {}
};

export const listPendingSubmissions = () => {
    const submissions = [];
    try {
        for (let index = 0; index < localStorage.length; index += 1) {
            const key = localStorage.key(index);
            if (!key?.startsWith(STORAGE_PREFIX)) continue;
            try {
                const value = JSON.parse(localStorage.getItem(key));
                if (value?.attemptId && value?.examId && Array.isArray(value.answers)) {
                    submissions.push(value);
                } else {
                    localStorage.removeItem(key);
                }
            } catch {
                localStorage.removeItem(key);
            }
        }
    } catch {}
    return submissions;
};

export const isRetryableSubmissionError = (error) => (
    !error?.status || error.status === 408 || error.status === 429 || error.status >= 500
);

export const isAlreadyFinalized = (value) => [
    value?.submission_state, value?.code, value?.data?.code, value?.data?.submission_state,
].some((code) => String(code || '').toLowerCase() === 'already_finalized');

export const getAutosaveRetryDelay = (retryCount = 0) => (
    Math.min(30000, 5000 * (2 ** Math.max(0, Number(retryCount) - 1)))
);

export const getSubmissionRetryAt = (error, retryCount = 1, now = Date.now()) => {
    const count = Math.max(1, Number(retryCount) || 1);
    const fallback = error?.status === 429
        ? Math.min(120000, 60000 * (2 ** Math.min(count - 1, 1)))
        : Math.min(30000, 10000 * (2 ** Math.min(count - 1, 2)));
    const retryAfter = Number(error?.retryAfter);
    const delay = error?.status === 429 && Number.isFinite(retryAfter) && retryAfter > 0
        ? Math.ceil(retryAfter * 1000)
        : fallback;
    return now + delay;
};
